import { systemTexts } from 'constants/localization';

import {
  EQuantityFieldControl,
  EQuantityFormatKey,
  IQuantityFieldDescriptor,
  IQuantityFormat,
  IQuantityFormatSection,
  IStoreSettingsFormValues
} from './StoreSettings.types';

const defaultQuantityFormat: IQuantityFormat = {
  milSeparator: ',',
  fractionalSeparator: '.',
  thousandShorthand: false,
  millionShorthand: false,
  billionShorthand: false,
  trillionShorthand: false,
  quadrillionShorthand: false,
  quintillionShorthand: false,
  sextillionShorthand: false,
  septillionShorthand: false,
  digitsBasedAbbreviation: false,
  maxDigitsWithoutShorthand: 3
};

export const defaultStoreSettings: IStoreSettingsFormValues = {
  productsQuantityFormat: { ...defaultQuantityFormat },
  balanceQuantityFormat: { ...defaultQuantityFormat },
  specialOfferQuantityFormat: { ...defaultQuantityFormat },
  rollingOfferQuantityFormat: { ...defaultQuantityFormat },
  progressBarQuantityFormat: { ...defaultQuantityFormat },
  triggeredPopupQuantityFormat: { ...defaultQuantityFormat }
};

export const QUANTITY_FORMAT_SECTIONS: IQuantityFormatSection[] = [
  {
    key: EQuantityFormatKey.PRODUCTS,
    title: systemTexts.settingsTexts.TITLES.BUNDLE_QUANTITY_FORMAT
  },
  {
    key: EQuantityFormatKey.BALANCE,
    title: systemTexts.settingsTexts.TITLES.BALANCE_QUANTITY_FORMAT
  },
  {
    key: EQuantityFormatKey.SPECIAL_OFFER,
    title: systemTexts.settingsTexts.TITLES.SPECIAL_OFFER_QUANTITY_FORMAT
  },
  {
    key: EQuantityFormatKey.ROLLING_OFFER,
    title: systemTexts.settingsTexts.TITLES.ROLLING_OFFER_QUANTITY_FORMAT
  }
];

export const QUANTITY_FORMAT_FIELDS: IQuantityFieldDescriptor[] = [
  {
    key: 'milSeparator',
    header: 'Thousands separator',
    control: EQuantityFieldControl.SEPARATOR,
    gridSize: 6
  },
  {
    key: 'fractionalSeparator',
    header: 'Decimal separator',
    control: EQuantityFieldControl.SEPARATOR,
    gridSize: 6
  },
  {
    key: 'thousandShorthand',
    header: 'Abbreviate thousands (K)',
    control: EQuantityFieldControl.BOOLEAN,
    gridSize: 2
  },
  {
    key: 'millionShorthand',
    header: 'Abbreviate millions (M)',
    control: EQuantityFieldControl.BOOLEAN,
    gridSize: 2
  },
  {
    key: 'billionShorthand',
    header: 'Abbreviate billions (B)',
    control: EQuantityFieldControl.BOOLEAN,
    gridSize: 2
  },
  {
    key: 'trillionShorthand',
    header: 'Abbreviate trillions (T)',
    control: EQuantityFieldControl.BOOLEAN,
    gridSize: 2
  },
  {
    key: 'quadrillionShorthand',
    header: 'Abbreviate quadrillions (Q)',
    control: EQuantityFieldControl.BOOLEAN,
    gridSize: 2
  },
  {
    key: 'quintillionShorthand',
    header: 'Abbreviate quintillions (Qi)',
    control: EQuantityFieldControl.BOOLEAN,
    gridSize: 2
  },
  {
    key: 'digitsBasedAbbreviation',
    header: 'Digits based abbreviation',
    control: EQuantityFieldControl.BOOLEAN,
    gridSize: 6
  },
  {
    key: 'maxDigitsWithoutShorthand',
    header: 'Max digits without shorthand',
    control: EQuantityFieldControl.NUMBER,
    gridSize: 6
  }
];
